import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarOutline = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 7.11249L23.8625 14.9375L32.5 16.1925L26.25 22.285L27.725 30.8875L20 26.8275L12.275 30.8875L13.75 22.285L7.5 16.1925L16.1375 14.9375L20 7.11249Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStarOutline);
export default ForwardRef;
